import requestClient from '../lib/requestClient';
import { handleApiErrors } from '../lib/utils';

/**
 * makes a user profile update request to the api
 * @function
 * @param {string} firstName - firstName
 * @param {string} lastName - lastName
 * @return {void}
 */
export const updateUserProfile = async (firstName, lastName) => {
	return await requestClient()
		.patch('/user/update', {
			firstName,
			lastName,
		})
		.catch((error) => {
			return handleApiErrors(error);
		});
};

/**
 * changes a user account status
 * @function
 * @param {string} userId - userId
 * @param {string} activate - activate
 * @return {void}
 */
export const changeStatus = async (userId, activate) => {
	return await requestClient()
		.patch(`/admin/user/${userId}`, {
			activate,
		})
		.catch((error) => {
			return { error: handleApiErrors(error) };
		});
};

/**
 * allows existing user to invite other users
 * @function
 * @param {string} email - email
 * @param {string} companyId - companyId
 * @param {string} roleId - roleId
 * @return {void}
 */
export const inviteNewUser = async (email, companyId, roleId) => {
	return await requestClient()
		.post('/admin/setup-user', {
			email,
			companyId,
			roleId,
		})
		.catch((error) => {
			return handleApiErrors(error);
		});
};

/**
 * fetches all users in the system
 * @function
 * @return {Array<Object>} users
 */
export const fetchUsers = async () => {
	return await requestClient()
		.get('/user')
		.catch((error) => {
			return { error: handleApiErrors(error) };
		});
};

/**
 * fetches all companies in the system
 * @function
 * @return {Array<Object>} companies
 */
export const fetchCompanies = async () => {
	return await requestClient()
		.get('/companies')
		.catch((error) => {
			return { error: handleApiErrors(error) };
		});
};

/**
 * fetches all roles
 * @function
 * @return {Array<Object>} roles
 */
export const fetchRoles = async () => {
	return await requestClient()
		.get('/roles')
		.catch((error) => {
			return { error: handleApiErrors(error) };
		});
};

/**
 * changes user password
 * @function
 * @return {void}
 */
export const changeUserPassword = async (currentPassword, newPassword) => {
	return await requestClient()
		.patch('/auth/changepassword', {
			currentPassword,
			newPassword,
		})
		.catch((error) => {
			return { error: handleApiErrors(error) };
		});
};
